module.exports = __webpack_public_path__ + "static/media/emerald.9d3c707c.png";